var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder_File_Management",
    "data-name": "Folder & File Management",
    transform: "translate(-63 -1979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(63 1979)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50721",
    "data-name": "Group 50721",
    transform: "translate(4 -156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50719",
    "data-name": "Group 50719",
    transform: "translate(-448.831 -662.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-minus",
    transform: "translate(526.831 2813.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39926",
    "data-name": "Path 39926",
    d: "M17.159,2H6.632A2.632,2.632,0,0,0,4,4.632V25.686a2.632,2.632,0,0,0,2.632,2.632h15.79a2.632,2.632,0,0,0,2.632-2.632V9.9Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39927",
    "data-name": "Path 39927",
    d: "M14,2V9.9h7.9",
    transform: "translate(-0.841 -2)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1008",
    "data-name": "Line 1008",
    x2: 2.972,
    transform: "translate(4.583 6.472)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1009",
    "data-name": "Line 1009",
    x2: 10.401,
    transform: "translate(4.583 14.644)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(539.903 2832.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39928",
    "data-name": "Path 39928",
    d: "M11.657,9.109a.956.956,0,0,0,.191,1.054l.035.035a1.159,1.159,0,1,1-1.639,1.639l-.035-.035a.963.963,0,0,0-1.633.683v.1a1.158,1.158,0,1,1-2.317,0v-.052a.956.956,0,0,0-.626-.875.956.956,0,0,0-1.054.191l-.035.035a1.159,1.159,0,1,1-1.639-1.639l.035-.035a.963.963,0,0,0-.683-1.633h-.1a1.158,1.158,0,1,1,0-2.317h.052a.956.956,0,0,0,.875-.626.956.956,0,0,0-.191-1.054l-.035-.035A1.159,1.159,0,1,1,4.5,2.906l.035.035a.956.956,0,0,0,1.054.191h.046a.956.956,0,0,0,.579-.875v-.1a1.158,1.158,0,1,1,2.317,0v.052a.963.963,0,0,0,1.633.683l.035-.035A1.159,1.159,0,1,1,11.837,4.5l-.035.035a.956.956,0,0,0-.191,1.054v.046a.956.956,0,0,0,.875.579h.1a1.158,1.158,0,1,1,0,2.317h-.052A.956.956,0,0,0,11.657,9.109Z",
    transform: "translate(-1 -1)",
    fill: "#fee8d3",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1929",
    "data-name": "Ellipse 1929",
    cx: 1.486,
    cy: 1.486,
    r: 1.486,
    transform: "translate(4.885 4.885)",
    fill: "#fb8b23"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(71 2147)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.83605c7201663d99a77efcf149cd6059.svg";
export { ForwardRef as ReactComponent };